import {
  toggleLinks,
  initComponents,
  fixVH,
  scrollToLinks,
  markLazyLoadedImages,
  lazyLoadVideos,
  inFieldLabels,
  markScrolledDown,
  markScrollDirection,
  markItemsInViewport,
  markEmpty, markImageCornerLightness,
} from "@/utils";


const win = <any>window;
const $ = win.jQuery;


window.addEventListener('DOMContentLoaded', async () => {
  win.__webpack_public_path__ = (<any>window).siteOptions.themePath + '/js/public/';

  fixVH();
  lazyLoadVideos();
  inFieldLabels();
  markScrolledDown();
  markScrollDirection();
  markEmpty();
  pushAnimations();

  const imagesSelector = 'img:not(.no-corner-lightness)';
  markImageCornerLightness(imagesSelector, 180);
  window.addEventListener('load', () => markImageCornerLightness(imagesSelector, 180));

  initComponents([
    'panel-toggle', 'menu-toggle', 'toggle-class', 'calculate-height', 'newsletter-form',
    'check-intersection', 'swiper-slideshow', 'scroll-to', 'custom-select', 'focus-trap',
    'homerun-menu', 'animated-grid', 'homerun-projects', 'simulate-hovers-underneath', 'swipe-hover', 'multiline-marquee',
    'in-viewport', 'pane-slider', 'homerun-logo-animation', 'lenis-loader', 'section-scroll',
  ]);


  document.documentElement.classList.add('is-loaded');
});

/**
 *  Mark items in viewport, for the "push" animation
 */
function pushAnimations() {
  let headerHeight =  $('.header').height();
  markItemsInViewport('.push, .line, .with-line, [data-viewport-group], [data-viewport-group-once]', `0% 0% -${headerHeight}px 0%`);
}

